module.exports.write = function write(namespace, key, value) {
  const serializedData = localStorage.getItem(namespace);
  const data = serializedData ? JSON.parse(serializedData) : {};
  data[key] = value;
  localStorage.setItem(namespace, JSON.stringify(data));
};

module.exports.read = function read(namespace, key) {
  const serializedData = localStorage.getItem(namespace);
  const data = JSON.parse(serializedData);
  return data ? data[key] : undefined;
};

module.exports.clear = function clear() {
  localStorage.setItem(namespace, JSON.stringify({}));
};

module.exports.remove = function remove(namespace, key) {
  const serializedData = localStorage.getItem(namespace);
  const data = serializedData ? JSON.parse(serializedData) : {};
  delete data[key];
  localStorage.setItem(namespace, JSON.stringify(data));
};
